
class ProductPage {
  constructor(page) {
    this.page = page;
    this.moreParamsLink = page.querySelector('[data-more-params]');

    this.bind();
  }

  bind() {
    if (this.moreParamsLink) {
      this.moreParamsLink.addEventListener('click', (e) => {
        e.preventDefault();
        const tab =  this.page.querySelector('[data-tab-key="product-params"]');
        if (tab) {
          tab.dispatchEvent(new Event('click'));
        }

      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('[data-product-page]');
  if (page) {
    new ProductPage(page);
  }
});